module.exports = __webpack_public_path__ + "3bf3686d4948741886debd2b80c9f8e2.png";